import React, { useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import GetAppIcon from "@material-ui/icons/GetApp";
import * as Dati from "src/Dati";
import * as Glob from "src/Globale";
import useReducerOnChange from "src/hooks/ReducerOnChange";
import ChiamaWeb, {CChiamaWebParametri} from "src/ChiamaWeb";
import { Trad } from "src/components/";
import { _Button, _ButtonAPI, _EconomicDataFormContent } from "..";
import { AlertDialogContext } from "../../providers/AlertDialogProvider";

interface IEconomicDataFormProps {
    BaseURL: string;
    ID_Anag: number;
    ID_DatoEconomico: number;
}

export const _EconomicDataForm: React.FC<IEconomicDataFormProps> = ({ BaseURL, ID_Anag, ID_DatoEconomico }) => {
    const history = useHistory();
    const { ShowDialog } = useContext(AlertDialogContext);
    const [Data, setData] = useReducerOnChange<Dati.CDatiEconomici>({ ...new Dati.CDatiEconomici(), ID_Anag });

    useEffect(() => {
        if (ID_DatoEconomico) {
            GetData();
        } else {
            setData({ Type: "Set", Value: { ...new Dati.CDatiEconomici(), ID_Anag } });
        }
    }, [ID_DatoEconomico]);

    const OnApiError = (error: Error) => {
        ShowDialog("ERRORE", error.message, "error");
    };

    const GetData = (): void => {
        const Param: CChiamaWebParametri = {
            URL: `/api/DatiEconomici/seleziona?ID_DatoEconomico=${ID_DatoEconomico}`,
            OnRis: OnGetData,
            OnErrore: (sender: ChiamaWeb, error: Error) => OnApiError(error)
        };
        new ChiamaWeb().Chiama(Param);
    };

    const OnGetData = (sender: ChiamaWeb, data: Dati.CRisAPIDatoDatiEconomici) => {
        if (data?.Dato?.ID_DatoEconomico) {
            setData({ Type: "Set", Value: data.Dato });
        } else {
            history.push(`${BaseURL}/0`);
        }
    };

    const GetFormData = (): Dati.CIngrAPI<Dati.CDatiEconomici> => {
        const formData = new Dati.CIngrAPI<Dati.CDatiEconomici>();
        formData.Dato = Data;

        return formData;
    };

    const OnClickSave = (data: Dati.CRisAPI) => {
        if (data.Errore) {
            ShowDialog("ERRORE", data.ErrTesto, "error");
        } else {
            ShowDialog("DATI ECONOMICI", Trad.TradParam("Dati economici salvati correttamente con ID: {1-S}", [data.ID_Chiave]), "success");
            history.push(`${BaseURL}/${data.ID_Chiave}`);
        }
    };

    const OnClickExtract = (data: Dati.CRisAPIDatoDatiEconomici) => {
        if (data.Errore) {
            ShowDialog("ERRORE", data.ErrTesto, "error");
        } else {
            ShowDialog("DATI ECONOMICI", Trad.Trad("DatiEconomiciEstrattiCorrettamente"), "success");
            history.push(`${BaseURL}/${data.ID_Chiave}`);
        }
    };

    const editingRights = Glob.AzioneAbilitata("DatiEconomiciController", Glob.Scrittura);

    return (
        <Card>
            <CardContent>
                <_EconomicDataFormContent
                    Data={Data}
                    ID_Anag={ID_Anag}
                    OnChange={(e, val) => setData({ Type: "OnChangeFromHybrid", NameEvent: val != null && val != undefined ? e : Object.assign({}, e), Value: val })}
                />
            </CardContent>
            <CardActions disableSpacing>
                <Grid item container xs={12} spacing={3} justify="flex-end">
                    {!!ID_DatoEconomico && Data.NomeFileReport && (
                        <Grid item xs={12} sm="auto">
                            <Button
                                fullWidth
                                component="a"
                                variant="outlined"
                                color="secondary"
                                href={`/api/DatiEconomici/Scarica?ID_DatoEconomico=${ID_DatoEconomico}&Sessione=${Glob.GetSessione().Sessione}`}
                                endIcon={<GetAppIcon />}
                            >
                                {Trad.Trad("DownloadReport")}
                            </Button>
                        </Grid>
                    )}
                    {editingRights && (
                        <>
                            <Grid item xs={12} sm="auto">
                                <_ButtonAPI Attivo Testo={Trad.Trad("Estrai dati")} URL="/api/DatiEconomici/EstraiDati" OnInvio={GetFormData} OnClick={OnClickExtract} OnErrore={OnApiError} />
                            </Grid>
                            <Grid item xs={12} sm="auto">
                                <_Button Default={false} WithWrapper={false} Testo={Trad.Trad("Annulla")} OnClick={GetData} />
                            </Grid>
                            <Grid item xs={12} sm="auto">
                                <_ButtonAPI Default Attivo Testo={Trad.Trad("Salva")} URL="/api/DatiEconomici" OnInvio={GetFormData} OnClick={OnClickSave} OnErrore={OnApiError} />
                            </Grid>
                        </>
                    )}
                </Grid>
            </CardActions>
        </Card>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/EconomicData/EconomicDataForm.tsx